// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InsertRowRightOutlinedSvg from "@fishx/icons-svg/es/asn/InsertRowRightOutlined";
import FishxIcon from '../components/FishxIcon';

var InsertRowRightOutlined = function InsertRowRightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: InsertRowRightOutlinedSvg
  }));
};

InsertRowRightOutlined.displayName = 'InsertRowRightOutlined';
export default React.forwardRef(InsertRowRightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/InsertRowRightOutlined.js
// module id = 2977
// module chunks = 0